import React, { useContext, useEffect } from "react";
import { OutboundConfigContext } from "../outboundAmzl/context/OutboundConfigContext";
import OutboundOverviewARV2 from "../outboundARv2/OutboundOverviewARV2";
import OutboundOverview from "./OutboundOverview";
import {
  getDocumentURL,
  getNodeCapability,
} from "../handler/ParentDataHandler";
import { CapabilityContext } from "../overview/context/CapabilityContext";
import { getBaseUrl } from "../outboundAmzl/util/Util";

const OutboundPredicate = () => {
  const { outboundConfigModel, configDispatcher } = useContext(
    OutboundConfigContext,
  );
  const { capability, dispatch: capabilityDispatch } =
    useContext(CapabilityContext);

  useEffect(() => {
    Promise.all([getDocumentURL(), getNodeCapability()]).then((result) => {
      const baseUrl = getBaseUrl(result[0]);
      configDispatcher({
        type: "GET_STATION_CONFIG",
        data: {
          dispatcher: configDispatcher,
          baseUrl: baseUrl,
        },
      });
      capabilityDispatch({ type: "GET_CAPABILITIES", capabilities: result[1] });
    });
  }, []);

  const renderView = () => {
    if (outboundConfigModel.stationConfig.sccV2OutboundViewForAREnabled) {
      return <OutboundOverviewARV2 />;
    } else {
      return <OutboundOverview />;
    }
  };

  return (
    <div>
      {capability.data !== "" && outboundConfigModel.stationConfig.initialised
        ? renderView()
        : null}
    </div>
  );
};

export default OutboundPredicate;



// WEBPACK FOOTER //
// ./src/components/outboundOverview/OutboundPredicate.js